const inputCls = "w-full rounded-xl border border-[#EBE4DA] bg-white px-4 py-3 text-base text-[#2D2824] focus:outline-none focus:ring-2 focus:ring-[#36858B]/40";

export const GiftForm = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="space-y-4 rounded-2xl bg-white p-5 ring-1 ring-[#EBE4DA]">
      <div>
        <label htmlFor="gift-recipient" className="mb-1.5 block text-sm font-medium text-[#2D2824]">Who is this gift for?</label>
        <input id="gift-recipient" data-testid="gift-recipient" maxLength={60} value={value.recipient_name} onChange={set("recipient_name")} placeholder="e.g. Grandma Rosa" className={inputCls} />
      </div>
      <div>
        <label htmlFor="gift-from" className="mb-1.5 block text-sm font-medium text-[#2D2824]">From</label>
        <input id="gift-from" data-testid="gift-from" maxLength={60} value={value.from_name} onChange={set("from_name")} placeholder="Your name" className={inputCls} />
      </div>
      <div>
        <label htmlFor="gift-message" className="mb-1.5 block text-sm font-medium text-[#2D2824]">A personal message (optional)</label>
        <textarea id="gift-message" data-testid="gift-message" maxLength={300} rows={3} value={value.message} onChange={set("message")}
          placeholder="Your stories matter to us. We can't wait to read them." className={inputCls} />
        <p className="mt-1 text-right text-xs text-[#8A7F76]">{value.message.length}/300</p>
      </div>
    </div>
  );
};

export const GiftPreview = ({ value, occasion }) => (
  <div data-testid="gift-preview" className="self-start rounded-2xl border-2 border-[#D9A036] bg-[#FAF6F0] p-2 shadow-sm">
    <div className="rounded-xl border border-[#E06D53]/50 px-5 py-8 text-center sm:px-8">
      <img src="/brand/yljm-emblem.png" alt="" className="mx-auto h-12 w-12" />
      <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.25em] text-[#36858B]">Gift certificate</p>
      {occasion && <p data-testid="gift-preview-occasion" className="mt-1 text-xs font-semibold text-[#C58F28]">{occasion}</p>}
      <p className="mt-3 font-serif text-2xl italic text-[#2D2824] sm:text-3xl">A gift of Lifetime Access</p>
      <p className="mt-3 text-sm text-[#6E665E]">lovingly given to</p>
      <p className="mt-1 break-words font-serif text-3xl font-semibold italic text-[#E06D53]">{value.recipient_name || "Their name"}</p>
      {value.message && <p className="mx-auto mt-4 max-w-sm break-words font-serif text-lg italic leading-snug text-[#2D2824]">“{value.message}”</p>}
      <p className="mt-4 text-sm text-[#6E665E]">with love from {value.from_name || "you"}</p>
      <p className="mx-auto mt-6 inline-block rounded-lg border border-[#D9A036] bg-white px-5 py-2 font-mono text-lg tracking-wider text-[#2D2824]">GIFT-XXXX-XXXX</p>
      <p className="mt-3 text-xs text-[#8A7F76]">Your real code appears after payment</p>
    </div>
  </div>
);
